module.exports = __webpack_public_path__ + "static/img/banner5.b6fc8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner5.jpg
// module id = ynUN
// module chunks = 0